import { render, staticRenderFns } from "./ImarikaPlan.vue?vue&type=template&id=1647d2c6&scoped=true"
import script from "./ImarikaPlan.vue?vue&type=script&lang=js"
export * from "./ImarikaPlan.vue?vue&type=script&lang=js"
import style0 from "./ImarikaPlan.vue?vue&type=style&index=0&id=1647d2c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1647d2c6",
  null
  
)

export default component.exports